import { Injectable, signal, TemplateRef, Type } from '@angular/core';
import { ToastSuccessComponent } from './toast-component/toast-templates/succes-toast.component';
import { ToastErrorComponent } from './toast-component/toast-templates/error-toast.component';
import { ToastInfoComponent } from './toast-component/toast-templates/info-toast.component';

export type Toast = {
  template?: TemplateRef<unknown>;
  component?: Type<unknown>;
  componentInputs?: Record<string, unknown>;
  classname?: string;
  delay?: number;
  autohide?: boolean; // Add this
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  private show(toast: Toast): void {
    this._toasts.update((toasts) => [...toasts, toast]);
  }

  remove(toast: Toast): void {
    this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
  }

  clear(): void {
    this._toasts.set([]);
  }

  success(message: string): void {
    this.show({
      component: ToastSuccessComponent,
      componentInputs: { message },
      classname: 'bg-success text-white',
    });
  }

  error(message: string): void {
    this.show({
      component: ToastErrorComponent,
      componentInputs: { message },
      classname: 'bg-danger text-white',
      autohide: false,
    });
  }

  info(message: string): void {
    this.show({
      component: ToastInfoComponent,
      componentInputs: { message },
      classname: 'bg-info text-white',
    });
  }
}
